import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import type { GuidanceState } from '~/utils/guidanceTypes'
import { STATE_ICONS } from '~/utils/guidanceTypes'
import { parseGuidanceTags } from '~/utils/guidanceTagParser'


export default /*#__PURE__*/_defineComponent({
  __name: 'GuidanceInline',
  props: {
    state: { default: 'safe' },
    message: { default: '' },
    icon: { default: undefined },
    replacements: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { state: GuidanceState, message: string, icon: [string, string] | null, replacements: Record<string, string> }



const stateClasses = computed(() => {
  switch (props.state) {
    case 'verified':
    case 'safe':
      return 'text-guidance-verified'
    case 'warn':
      return 'text-guidance-warn-text'
    case 'danger':
      return 'text-guidance-danger-text'
    default:
      return 'text-guidance-verified'
  }
})

const resolvedIcon = computed<[string, string] | null>(() => {
  if (props.icon !== undefined) return props.icon
  return STATE_ICONS[props.state] || null
})

const parsedMessage = computed(() =>
  parseGuidanceTags(props.message, props.replacements)
)

return { __sfc: true,props, stateClasses, resolvedIcon, parsedMessage }
}

})